import React from 'react';

import { Icon } from '@/new/components/icon';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/new/components/shadcn/tooltip';

interface TooltipIconProps {
  side?: 'top' | 'right' | 'bottom' | 'left';
  tooltipContent: string;
}

export const TooltipIcon: React.FC<TooltipIconProps> = React.memo(({ side, tooltipContent }) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger>
        <Icon className="lucide--info cursor-pointer text-gray-400" />
      </TooltipTrigger>

      <TooltipContent side={side ?? 'top'}>{tooltipContent}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
));
